$ = jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

jQuery(function ($) {

    // --- NAV ---

    $(".nav-search").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-search-modal .search-close").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-responsive").removeClass("active");
        $(".burger").removeClass("active")
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart-modal .cart-close").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-burger").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });

    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this);
        var $parent = $this.parents("li").first();

        var $subMenu = $("ul.sub-menu", $parent);
        if ($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-responsive ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        }
    });

    $(".page-single article .gallery br").remove();

    // --- BURGER ANIMATED ---

    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---

    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });

    // --- WORDPRESS FORM CONTROL ---

    $(".widget_archive select").addClass("form-control");
    $(".widget_categories select").addClass("form-control");
    $(".woocommerce-account .woocommerce").addClass("row justify-content-between");

    // --- WOOCOMMERCE ---

    $(".product-quantity-minus").click(function (e) {
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        var newQuantity = (currentQuantity >= 1) ? (currentQuantity - 1) : 0;
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });

    $(".product-quantity-plus").click(function (e) {
        var max_quantity = 99999;
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        if (isNaN(currentQuantity)) currentQuantity = 0;
        var newQuantity = (currentQuantity >= max_quantity) ? max_quantity : (currentQuantity + 1);
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });

    $(document.body).trigger('wc_fragment_refresh');

    // --- FORMULAIRE DEMANDE DIAG CONF ---
    $("#container-radio-type-bien input[name=type]").on("change", function () {
        var label;
        if ($(this).val() == "Vous êtes un particulier") {
            label = "Nom et prénom du propriétaire du bien";
        } else {
            label = "Nom de l'entité";
        }
        $("#label-type-name").html(label);
    });


    $(".identification-bien-autre").parents("p").first().hide();
    $(".statut-demandeur-autre").parents("p").first().hide();
    $(".identification-bien input[name=identification-bien]").on("change", function () {
        if ($("input[name=identification-bien]:checked").val() == "Autre") {
            $(".identification-bien-autre").parents("p").first().show();
        } else {
            $(".identification-bien-autre").parents("p").first().hide();
        }
    });

    $(".statut-demandeur input[name=statut-demandeur]").on("change", function () {
        if ($("input[name=statut-demandeur]:checked").val() == "Autre") {
            $(".statut-demandeur-autre").parents("p").first().show();
        } else {
            $(".statut-demandeur-autre").parents("p").first().hide();
        }
    });

    // si demandeur n'as pas d'adresse mail pour la réception du PV
    $('#no-mail').click(function () {
        if ($(this).is(':checked')) {
            $('#form-no-mail').removeAttr('hidden');
        } else {
            $('#form-no-mail').attr('hidden', '');
        }
    });

    // start form
    $('#form-start').click(function () {
        $('#form-start-content').hide();
        $('#step-1-form').removeAttr('hidden');
    });

    // montre le form de modification
    $('.js-toggle-form').click(function () {
        //unmask inputs
        $('input').removeAttr('hidden');
        $('.js-info-recap').each(function () {
            $(this).attr('hidden', 'hidden');
        });

        $('form').append('<input type="hidden" name="modifs" id="modifs" value="true">');

        $('.js-button-container').prepend('<button class="btn link reverse danger js-cancel-modifs"><span class="icon"><svg class="visible" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"></path></svg><svg class="hover" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z"></path></svg></span><span class="btn-title">Annuler</span></button>');

        $('.js-next-step-button').html('<span class="btn-title">Enregistrer</span><span class="icon"><svg class="visible" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"></path></svg><svg class="hover" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"></path></svg></span>');

        $(this).hide();
    });

    //cache le form de modification
    $(document).on('click', '.js-cancel-modifs', function () {
        //unmask inputs
        $('input').attr('hidden', 'hidden');
        $('.js-info-recap').removeAttr('hidden');

        $('form').remove('input[name="modifs"]');

        $('.js-toggle-form').show();

        $('.js-next-step-button').html('<span class="btn-title">Valider les informations ci-dessus</span><span class="icon"><svg class="visible" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"></path></svg><svg class="hover" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13.1714 12.0007L8.22168 7.05093L9.63589 5.63672L15.9999 12.0007L9.63589 18.3646L8.22168 16.9504L13.1714 12.0007Z"></path></svg></span>');

        $(this).remove();
    });

});

